import request from "root/js/request";

export const getParsersBrands = async ({ brand_id__in, ...rest } = {}) => {
  const response = await request({
    url: `parsers/brands/`,
    method: "get",
    params: {
      brand_id__in,
      ...rest,
    },
  });
  return response.data;
};
